function DownloadBtn($d) {
    var $label = $d.find(".label");
    var txtProc = $d.data("proc") || $label.data("proc");
    var txtDown = $d.data("down") || $label.data("down");
    var ready;
    var enabled;

    function toRenderState() {
        $d.removeClass("active");
        $label.text(txtProc);
    }
    function toDownloadState() {
        $d.addClass("active");
        $label.text(txtDown);
    }

    Object.defineProperty(this, "ready", {
        get: function () {
            return ready;
        },
        set: function (value) {
            var b = !!value;
            if (b !== ready) {
                ready = b;
                if (ready) {
                    toDownloadState();
                } else {
                    toRenderState();
                }
            }
        }
    });
    
    Object.defineProperty(this, "enabled", {
        get: function () {
            return enabled;
        },
        set: function (value) {
            var b = !!value;
            if (b !== enabled) {
                enabled = b;
                if (enabled) {
                    $d.css("display", "inline-block");
                } else {
                    $d.hide();
                }
            }
        }
    });    

    $d.click(function() {
        window.location.href = $d.data("href");
    });

    /*function updateDwVis() {
        var enabled = (data.photos.length>0) && data.canDownload;
        if (enabled) {
        } else {
            $dp.hide();
        }
    }

    function dataChange() {
        //data.isReady = false;
        updateDwVis();
    }*/    
    
}

module.exports = DownloadBtn;